<template>
	<div class="bottom-menu">
		<div class="menu-item" @click="toUrl('homeIndex')">
			<div class="icon"><img src="../../assets/images/home.png" /></div>
			<div class="text">首 页</div>
		</div>
		<div class="menu-item" @click="toArticleList(5)">
			<div class="icon"><img src="../../assets/images/vr.png" /></div>
			<div class="text">VR实景</div>
		</div>
		<div class="menu-item" @click="pushWithQuery(1)">
			<div class="icon"><img src="../../assets/images/map.png" /></div>
			<div class="text">产业地图</div>
		</div>
		<div class="menu-item" @click="toArticleList(4)">
			<div class="icon"><img src="../../assets/images/zhinan.png" /></div>
			<div class="text">招商指南</div>
		</div>
	</div>
</template>

<script>
	import {
		useRouter
	} from 'vue-router'
	import {
		defineComponent
	} from 'vue'
	export default defineComponent({
		setup() {
			const router = useRouter();

			function toUrl(routerName) {
				router.push({
					name: routerName,
				})
			}
			// 地图跳转
			function pushWithQuery(menuId) {
				sessionStorage.setItem('curMeunId', menuId);
				router.push({
					name: 'mapView',
				});
			}
			// 文章列表
			function toArticleList(typeId) {
				// console.log('点击事件', typeId);
				sessionStorage.setItem('typeId', typeId);
				router.push({
					name: 'articleList',
					query: {
						typeId: typeId
					}
				})
			}

			return {
				toUrl,
				pushWithQuery,
				toArticleList
			}
		}
	})
</script>

<style lang="scss">
	.bottom-menu {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		height: 50px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #fff;
		box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);
		padding: 10px 0px;
		z-index: 999;

		.menu-item {
			width: 25%;
			text-align: center;
			height: 100%;
			color: #666;
			cursor: pointer;
			transition: color 0.2s ease-in-out;

			.icon {
				height: 25px;

				img {
					width: 25px;
					height: 25px;
					margin: 0px;
					padding: 0px;
				}
			}

			.text {
				font-size: 14px;
				font-weight: bold;
				color: #0169f5;
				margin: 0px;
				padding: 0px;
			}
		}
	}
</style>